export default "__VITE_ASSET__DAKzUxCq__"